module.exports = __webpack_public_path__ + "img/domain_select.ef735530.png";